import axios from "axios";
import { DamageFormTypes } from "../Types";

function GeneratePurchaseOrderService(data: DamageFormTypes.PurchaseOrderFormTypes) {
    return axios.post("/masterdatadamage/damage/generate-purchase-order", {
        //repairShopSapId: data.repairShopSapId,
        //repairShopCity: data.repairShopCity,
        //plate: data.plate,
        //vin: data.vin,
        //damageDetail: data.damageDetail,
        //gridAmount: data.gridAmount,

        damageFormId: data.damageFormId,
        dealer: data.dealer,
        tenant: data.tenant,
        language: data.language,
        purchaseOrderDate: data.purchaseOrderDate,
        ivaPercentage: data.ivaPercentage ?? 20,
        ivaPrice: data.ivaPrice,
        ivaTotalPrice: data.ivaTotalPrice,
        totalGrossPrice: data.totalGrossPrice,
        totalNetPrice: data.totalNetPrice,
        totalPrice: data.totalPrice,
        repairShopAddress: data.repairShopAddress,
        repairShopBillingAddress: data.repairShopBillingAddress,
        purchaseElements: data.purchaseElements,

        // -----Valori non utilizzati nel pdf -----
        repairShopAddressCity: data.repairShopAddressCity,
        repairShopSiren: data.repairShopSiren,
        repairShopName: data.repairShopName,
        repairShopPhone: data.repairShopPhone,
        repairShopMail: data.repairShopMail,

        vehicleVin: data.vehicleVin,
        vatIncluded: data.vatIncluded,
        vatExcluded: data.vatExcluded,
        vatPerc: data.vatPerc,
        damageDate: data.damageDate,
        damageDetails: data.damageDetails,
        vehiclePlate: data.vehiclePlate,
        damageAmount: data.damageAmount,
    }).then(
        (response) => {
            return response.data
        }
    );
}

export default GeneratePurchaseOrderService;
